import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

export default function TextInputDialog(props) {
    const open = props.open;
    const confirm = props.confirm;
    const cancel = props.cancel;
    const viewText = props.viewText;
    const textFieldLabel = props.textFieldLabel;
    const [text, setText] = React.useState('');
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    useEffect(() => {
        setText(open && props.text ? props.text : '');
    }, [open, props.text]);

    const onChange = (evt) => {
        setText(evt.target.value);
    };

    if (open)
        return (
            <Dialog
                onClose={cancel}
                aria-labelledby="simple-dialog-title"
                open={open}
                fullWidth={true}
                maxWidth={'md'}
                fullScreen={fullScreen}>
                <DialogContent dividers>
                    <div>{viewText}</div>
                    <TextField
                        label={textFieldLabel}
                        sx={{ width: '100%' }}
                        name="textinputdialoginput"
                        value={text}
                        onChange={onChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        disabled={text.length < 3}
                        color="primary"
                        name="btn-modal-confirm"
                        onClick={() => confirm(text)}>
                        {t('buttons.save')}
                    </Button>
                    &nbsp;&nbsp;
                    <Button variant="contained" sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }} name="btn-modal-cancel" onClick={cancel}>
                        {t('buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    return null;
}
